module.exports = __webpack_public_path__ + "img/proses-pelunasan.d1207f91.svg";